
<template>
  <div class="page-wrapper">
    <NavBar class="style1" />
    <div class="content-wrapper">
      <PageTitle pageTitle="Recherches" />
      <RechercheTerm />
    </div>
    <FooterComp />
  </div>
</template>

<script>
import NavBar from '../Layouts/NavBar.vue'
import PageTitle from '../Common/PageTitle.vue'
import FooterComp from '../Layouts/FooterComp.vue'
import RechercheTerm from '../Recherches/RechercheTerm.vue'



export default {
  name: 'RecherchePage',
  components: {
    NavBar,
    PageTitle,
    RechercheTerm,
    FooterComp,
  }
}
</script>